/* eslint-disable react/prop-types */
/* eslint-disable  react/no-array-index-key */
/* eslint-disable  jsx-a11y/click-events-have-key-events */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import { Modal } from 'react-bootstrap';
import AppButton from '../../shared/components/app-button/AppButton';
import { formatCurrency } from '../../shared/helper-utils/appUtils';

export default function MealSelectionComponent({
  showMeals,
  setShowMeals,
  flightLegsWithMealRef,
  mealSelectionSector,
  setMealSelectionSector,
  userSelectedSsrRows,
  travellers,
  activeMealIndex,
  setActiveMealIndex,
  getSelectedMeals,
  handleRemoveMeal,
  handleAddMeal,
  isNormalBooking = true,
}) {
  const getByName = (userBaggageRows) => {
    return userBaggageRows.reduce((acc, cur) => {
      if (acc[cur.fullName]) {
        acc[cur.fullName].push(cur);
      } else {
        acc[cur.fullName] = [cur];
      }
      return acc;
    }, {});
  };
  return (
    <Modal
      className="app-modal meal-modal"
      show={showMeals}
      onHide={() => setShowMeals(false)}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>Meals</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="separator" />
        <div className="meal-sectors-row d-flex">
          {Object.keys(flightLegsWithMealRef).map((sector) => (
            <div
              key={sector}
              className={`meal-sector ${
                mealSelectionSector === sector ? 'active-meal-sector' : ''
              }`}
              onClick={() => setMealSelectionSector(sector)}
            >
              {sector}
            </div>
          ))}
        </div>
        <div className="separator" />
        {Object.keys(flightLegsWithMealRef).map((sector) => {
          const mealsList = flightLegsWithMealRef[sector];
          const userMealRows = userSelectedSsrRows[sector]?.mealRows || [];
          let byName;
          if (!isNormalBooking) {
            byName = getByName(userMealRows);
          }
          return (
            mealSelectionSector === sector && (
              <div key={sector}>
                <div className="d-flex p-3 travellers-info">
                  {isNormalBooking ? (
                    <>
                      {travellers.map(
                        (traveller, index) =>
                          traveller.type.toLowerCase() !== 'infant' && (
                            <div
                              className={`traveller-name ${
                                activeMealIndex === index && 'active-traveller'
                              }`}
                              key={index}
                              onClick={() => setActiveMealIndex(index)}
                            >
                              {traveller.first_name !== ''
                                ? `${traveller.title} ${traveller.first_name} ${traveller.last_name}`
                                : `Traveller ${index + 1}`}
                              <small className="traveller-name__subheading">
                                {getSelectedMeals(userMealRows, index)}
                              </small>
                            </div>
                          ),
                      )}
                    </>
                  ) : (
                    <>
                      {Object.keys(byName).map(
                        (fullName, index) =>
                          byName[fullName][0].paxtype.toLowerCase() !==
                            'infant' && (
                            <div
                              className={`traveller-name ${
                                activeMealIndex === index && 'active-traveller'
                              }`}
                              key={index}
                              onClick={() => setActiveMealIndex(index)}
                            >
                              {fullName}
                              <small className="traveller-name__subheading">
                                {getSelectedMeals(
                                  byName[fullName],
                                  index,
                                  sector,
                                )}
                              </small>
                            </div>
                          ),
                      )}
                    </>
                  )}
                </div>
                <div className="separator" />
                <div className="d-flex flex-wrap justify-content-between p-3">
                  {mealsList.map((meal, index) => (
                    <div
                      key={`${meal.ssrcode}_${index}`}
                      className="ssr-card p-2 mb-2"
                    >
                      <div>
                        <img
                          className="meal-image"
                          src={meal.imageurl}
                          alt={meal.ssrname}
                        />
                      </div>
                      <div className="ps-3 pe-3 w-100 d-flex flex-column">
                        <div className="flex-1">
                          <p className="ssr-card__meal-name">{meal.ssrname}</p>
                          <p className="ssr-card__meal-description">
                            {meal.Desc}
                          </p>
                        </div>
                        <div className="d-flex justify-content-between align-items-center">
                          <p className="ssr-card__meal-name">
                            {formatCurrency(meal.chargeableamount)}
                          </p>
                          {userMealRows[activeMealIndex].hasSsr ? (
                            ''
                          ) : (
                            <>
                              {userMealRows[activeMealIndex].ssrcode ===
                              meal.ssrcode ? (
                                <AppButton
                                  variant="outlined"
                                  className="ssr-card__add-btn"
                                  btnText="Remove"
                                  onClick={() =>
                                    handleRemoveMeal(
                                      meal,
                                      activeMealIndex,
                                      `${meal.origin} - ${meal.destination}`,
                                    )
                                  }
                                />
                              ) : (
                                <AppButton
                                  className="ssr-card__add-btn"
                                  btnText="Add"
                                  onClick={() => handleAddMeal(meal, sector)}
                                />
                              )}
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )
          );
        })}
      </Modal.Body>
      <Modal.Footer>
        <AppButton
          onClick={() => setShowMeals(false)}
          btnText="Continue"
          variant="outlined"
        />
      </Modal.Footer>
    </Modal>
  );
}
